import React, { useEffect, useMemo, useState } from 'react';
import { Column, Row } from 'react-table';

import { AdminVoucherCategoryDto, AdminVoucherDto, UserInfoDto } from 'services/data-contracts';
import TableBody from 'components/table/TableBody';
import { EditButton } from 'resources/styles/TableStyle';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import PaginationWrapper from '../Pagination';
import { useStoreWrapper } from 'stores/StoreHelper';

interface VoucherGroupTableProps {
  vouchers: AdminVoucherDto[];
  onRowClick?: (voucherGroup: AdminVoucherDto) => void;
  onEditClick?: (voucherGroup: AdminVoucherDto) => void;
}


// 테이블 데이터 타입 정의
const VouchersTable = observer(({ vouchers, onRowClick, onEditClick }: VoucherGroupTableProps) => {
  const { voucherFilterStore } = useStoreWrapper();

  // 테이블 컬럼 정의
  const columns = useMemo(
    () => [
      {
        Header: 'No',
        accessor: 'id' as keyof AdminVoucherDto,
        width: 60,
      },
      {
        Header: '할인유형',
        accessor: 'discountType' as keyof AdminVoucherDto,
        width: 100,
        Cell: ({ value }: { value: string }) => {
          return value === 'FIXED' ? '정액할인' : '비율할인';
        },
      },
      {
        Header: '코드',
        accessor: 'code' as keyof AdminVoucherDto,
        width: 100,
      },
      {
        Header: '한옥',
        accessor: 'listingSummary' as keyof AdminVoucherDto,
        width: 200,

      },
      {
        Header: '수량',
        accessor: 'qty' as keyof AdminVoucherDto,
        width: 200,
      },
      {
        Header: '금액',
        accessor: 'price' as keyof AdminVoucherDto,
        width: 120,
        Cell: ({ value }: { value: number }) => {
          return value ? value.toLocaleString() : '0';
        },
      },
      {
        Header: '숙박기간',
        accessor: 'stayStartDate' as keyof AdminVoucherDto,
        width: 120,
        Cell: ({ value }: { value: string }) => {
          return value ? new Date(value).toLocaleDateString('ko-KR') : '-';
        },
      },

      {
        Header: '상태',
        accessor: 'status' as keyof AdminVoucherDto,
        width: 80,
        Cell: ({ value }: { value: string }) => {
          switch (value) {
            case 'OPEN':
              return '사용가능';
            case 'USED':
              return '사용완료';
            case 'EXPIRED':
              return '기한만료';
            default:
              return '사용가능';
          }
        },
      },
      {
        Header: '만료일',
        accessor: 'expireDate' as keyof AdminVoucherDto,
        width: 120,
        Cell: ({ value }: { value: string }) => {
          return value ? new Date(value).toLocaleDateString('ko-KR') : '-';
        },
      },
      {
        Header: '생성자',
        accessor: 'creator' as keyof AdminVoucherDto,
        width: 120,
        Cell: ({ value }: { value: any }) => {
          return value ? value.username : '-';
        },
      },
      {
        Header: '생성일',
        accessor: 'createDate' as keyof AdminVoucherDto,
        width: 120,
        Cell: ({ value }: { value: string }) => {
          return value ? new Date(value).toLocaleDateString('ko-KR') : '-';
        },
      },
      {
        Header: '수정자',
        accessor: 'modifier' as keyof AdminVoucherDto,
        width: 120,
        Cell: ({ value }: { value: any }) => {
          return value ? value.username : '-';
        },
      },
      {
        Header: '수정일',
        accessor: 'modifyDate' as keyof AdminVoucherDto,
        width: 120,
        Cell: ({ value }: { value: string }) => {
          return value ? new Date(value).toLocaleDateString('ko-KR') : '-';
        },
      },
      {
        Header: '비고',
        accessor: 'remark' as keyof AdminVoucherDto,
        width: 120,
        Cell: ({ value }: { value: string }) => {
          return value ? (value.length > 20 ? value.substring(0, 20) + '...' : value) : '-';
        },

      },
      {
        Header: '수정',
        id: 'edit',
        width: 80,
        Cell: ({ row }: { row: Row<AdminVoucherDto> }) => <EditButton onClick={(e) => {
          e.stopPropagation();
          onEditClick?.(row.original as AdminVoucherDto);
        }}>수정</EditButton>,
      },
    ],
    [],
  ) as Column<UserInfoDto>[];


  return (
    <div>
      <div style={{ paddingBottom: '100px' }}>
        <TableBody columns={columns} data={vouchers} onRowClick={onRowClick} />
      </div>
      <PaginationContainer>
        <PaginationWrapper count={voucherFilterStore.paginationInfo?.totalCount ?? 0}
          totalPages={voucherFilterStore.paginationInfo?.totalPages ?? 0} />
      </PaginationContainer>
    </div>
  );
});

const PaginationContainer = styled.div`
    margin-top: 20px;
    position:fixed;
    bottom:0;
    z-index:10;
    margin:auto;
    background:rgba(255,255,255,1);
    backdrop-filter: blur(10px);
    left:0;
    right:0;

    display:flex;
    justify-content:center;
    align-items:center;

`;

export default VouchersTable;
